<template>
	<div class="vote_index">
		<div class="top"></div>
		<div class="vote_index_header">
			<van-image round width="1.05rem" height="1.05rem" :src="userinfo.avatarurl"/>
			<div class="vote_index_header_info">
				<div class="vote_index_header_info_user">
					<div class="vote_index_header_info_user_id">NO.{{userinfo.id}}</div>
					<div class="vote_index_header_info_user_name">{{userinfo.name}}</div>
				</div>
				<div class="vote_index_header_info_new">
					票数：<span>{{userinfo.votes}} 票</span>
				</div>
			</div>
		</div>
		<div class="vote_index_body">
			<div class="mvbutton introduce">
	             选手介绍
            </div>
            <div class="vote_index_body_content">{{userinfo.title}}</div>	
            <van-image width="5.74rem" height="3.55rem" :src="userinfo.imgurl" @click="gotouch"/>  
	        <div class="mvbutton vote" @click="go">
	             投票
            </div>	
		</div>	
		<div class="footer">
            <div class="mvbutton" @click="signup">
                我要报名
            </div>
        </div>
        <van-popup v-model="show" closeable :style="{ height: '100%',width: '100%' }" :close-icon="require('assets/img/common/colse.svg')">
            <video
              id="video" 
              class="video" 
              :src="userinfo.mediaurl"
              controls = "true"
              :poster="userinfo.imgurl"
              preload="auto" 
              webkit-playsinline="true" 
              playsinline="true"
              x-webkit-airplay="allow" 
              x5-video-player-type="h5"
              x5-video-player-fullscreen="true"
              x5-video-orientation="portraint"
              style="object-fit:fill">
            </video> 
        </van-popup>
	</div>
</template>
<script>
    import './index.less'
    import { Image, Popup } from 'vant'; 
    import storage from 'libs/storage'
    import VoteList from '@/views/WholeFamily/VoteList'
    import RankList from '@/views/WholeFamily/RankList'
    export default {
        data(){
          return {
              userinfo:{},
              show:false
          }
        },
        components:{
        	vanImage:Image,
            vanPopup:Popup,
        	VoteList,
        	RankList
        },
        methods:{
        	go(){
        		this.$api.family.submitVote({vcid: this.userinfo.vcid,vid: this.userinfo.vid}).then((res) => {
                    if (res.status * 1 === 200) {
                        this.$toast.success('投票成功！');
                        this.$router.push({name:'familydetail'})
                    }
                });
        	},
        	signup(){
            	this.$router.push({name:'familysignup'})
            },
            gotouch() {
                this.show = true
                // var myVideo=document.getElementById("video");
                // myVideo.play();
                // if (myVideo.paused) 
                //   myVideo.play(); 
                // else 
                //   myVideo.pause(); 
            }
        },
        mounted(){
            let info = localStorage.getItem('vote');
            this.userinfo = JSON.parse(info);
            this.userinfo.imgurl = this.userinfo.mediaurl+'?x-oss-process=video/snapshot,t_5000,f_jpg,w_574,h_355,ar_auto'
        }
    }
</script>